import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '70%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
    row3: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const CapTableTableFooter = ({items}) => {
    const total = items.map(item => item.total_shares)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0)

    const percent = items.map(item => item.percent_shares)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0)

    return(    
        <View style={styles.row}>
            <Text style={styles.description}>TOTAL</Text>
            <Text style={styles.total}>{ Number.parseInt(total)}</Text>
            <Text style={styles.total}>{ Number.parseInt(percent)}</Text>
        </View>
    )
};
  
  export default CapTableTableFooter